import { render, staticRenderFns } from "./ResultadosInfoCard.vue?vue&type=template&id=94bb6994"
import script from "./ResultadosInfoCard.vue?vue&type=script&lang=js"
export * from "./ResultadosInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ResultadosInfoCard.vue?vue&type=style&index=0&id=94bb6994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports